<template>
  <div class="preview-dialog">
    <el-dialog title="调查统计表预览" :visible.sync="previewDialogVisible" :before-close="dialogClose" width="750px">
      <div class="table" v-if="ruleForm">
        <div class="title">
          {{ ruleForm.formName }}
        </div>
        <div class="end-time">结束时间：{{ ruleForm.endTime }}</div>
        <div class="description" v-html="ruleForm.description"></div>
        <el-divider></el-divider>
        <el-form>
          <el-form-item v-for="(item, index) in questionList" :key="index" :label="index + 1 + '.' + item.title"
            :label-position="labelPosition" :required="item.isRequired == '1' ? true : false" style="text-align: left">
            <div style="color: #909399;">{{ item.description }}</div>
            <el-radio-group v-model="item.val" v-if="item.problemType == '1'" :disabled="disabled">
              <el-radio v-for="(rItem, rIndex) in item.surveyOptionsList" :key="rIndex" :label="rItem.optionContent"
                style="display: block; margin: 8px 0;"></el-radio>
            </el-radio-group>
            <el-checkbox-group style="margin-top: 32px;" v-model="item.checkedVal" v-if="item.problemType == '2'" :disabled="disabled">
              <el-checkbox v-for="(eItem, eIndex) in item.surveyOptionsList" :key="eIndex" :label="eItem.optionContent"
                :name="eItem.optionContent" style="width: 100%;"></el-checkbox>
            </el-checkbox-group>
            <el-select v-model="item.val" placeholder="请选择" v-if="item.problemType == '3'" :disabled="disabled">
              <el-option v-for="(oItem, oIndex) in item.surveyOptionsList" :key="oIndex" :label="oItem.optionContent"
                :value="oItem.optionContent"></el-option>
            </el-select>
            <el-input v-if="item.problemType == '4'" v-model="item.val" :disabled="disabled"></el-input>
            <el-upload v-if="item.problemType == '5'" action="#" list-type="picture-card" :disabled="true">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["previewDialogVisible", "ruleForm"],
  data() {
    return {
      disabled: false,
      labelPosition: "top",
      questionList: []
    };
  },
  mounted() {
    // console.log("questionList：", this.questionList);
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:previewDialogVisible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./previewDialog.scss";
</style>